/* eslint-disable no-unused-vars */
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import FetchInterceptor from 'fetch-interceptor';
import 'moment/locale/ko';
import './css/index.css';
import App from './App';
import * as serviceWorker from './registerServiceWorker';
import { getUserPId, Log, getSerials } from './common/util';
import { piboInit } from './pibo';

moment.locale('ko');

FetchInterceptor.register({
  onBeforeRequest(request) {
    request.headers.append('Access-Control-Allow-Origin', '*');
    request.headers.append(
      'Access-Control-Allow-Methods',
      'GET, POST, PUT, DELETE, OPTIONS',
    );
    request.headers.append(
      'Access-Control-Allow-Headers',
      'Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Authorization, x-client-type, x-client-id',
    );
    request.headers.append('Access-Control-Max-Age', 3600);
    if (getUserPId()) {
      request.headers.append(
        'x-client-type',
        '5d637b7f40154329a4aba7095214c90868a3a167',
      );
      request.headers.append('x-client-id', getUserPId());
    } else {
      request.headers.append(
        'x-client-type',
        '5d637b7f40154329a4aba7095214c90868a3a167',
      );
      request.headers.append('x-client-id', '5d9031b06ad9bf03c0045ac4');
    }
  },
  onRequestSuccess(response, request) {
    // Hook on response success
    // Log('SUCCESS', response, request);
  },
  onRequestFailure(response, request) {
    // Hook on response failure
    // Log('FAILURE', response, request);
  },
});

piboInit(getSerials());

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    } else {
      window.location.reload();
    }
  },
});
